import { useContext } from 'react';
import { Avatar, Box, Card, Chip, Grid, Typography } from '@mui/material'
import { SocketContext } from '../../context/SocketContext';
import { useNavigate } from 'react-router-dom';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import FechaFunction from '../../function/FechaFunction';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import GroupIcon from '@mui/icons-material/Group';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
const CardNotifications = ({item,onCloseModal,isDarkMode}) => {
    const navigate = useNavigate();
    const { sockets } = useContext( SocketContext );
    const redirect = ()=>{
        if(!item?.visto_notf){
            sockets?.emit('newNotifications', item?.id_notf)
        }
        if(item?.empresa_notf === 'strong'){
            navigate(`/ticket/${item?.ticketId_notf}/strongsystems`)
        }else{
            navigate(`/ticket/${item?.ticketId_notf}/${item?.empresa_notf}`)
        }
        if(onCloseModal){
            onCloseModal()
        }
    }
    const getCompanyInfo = (empresa) => {
        const companies = {
            'nubicom': { logo: '/img/nubi-cirucular.png', name: 'Nubicom', color: '#0364FF' },
            'ids': { logo: '/img/ids-logo.png', name: 'IDS', color: '#10b981' },
            'strong': { logo: '/img/strong-logo.png', name: 'Strong', color: '#f59e0b' },
            'cvv': { logo: '/img/911-logo.png', name: 'CVV', color: '#ef4444' }
        };
        return companies[empresa] || { logo: '', name: empresa, color: '#6b7280' };
    };

    const getAssignmentInfo = (tipoDestino, grupo) => {
        if (tipoDestino === 'DNI') {
            return {
                text: 'Te asignó',
                icon: <AssignmentIndIcon sx={{ fontSize: 14 }} />,
                color: '#0364FF'
            };
        } else if (tipoDestino === 'GRUPO') {
            return {
                text: `Asignó al grupo ${grupo}`,
                icon: <GroupIcon sx={{ fontSize: 14 }} />,
                color: '#10b981'
            };
        }
        return { text: 'Actualizó', icon: null, color: '#6b7280' };
    };

    const companyInfo = getCompanyInfo(item?.empresa_notf);
    const assignmentInfo = getAssignmentInfo(item?.tipoDestino_notf, item?.sendgrupo?.nombre_g);

    return (
        <Card
            sx={{
                background: item?.visto_notf 
                    ? isDarkMode 
                        ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)'
                        : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)' 
                    : isDarkMode
                        ? 'linear-gradient(135deg, #1a2744 0%, #243352 100%)'
                        : 'linear-gradient(135deg, #e6f0ff 0%, #f0f8ff 100%)',
                border: item?.visto_notf 
                    ? isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e7ed' 
                    : `1px solid ${companyInfo.color}40`,
                borderRadius: 3,
                p: 1.5,
                mt: 1,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                position: 'relative',
                overflow: 'hidden',
                '&:hover': {
                    transform: 'translateX(4px)',
                    boxShadow: `0 4px 20px ${companyInfo.color}20`,
                    border: `1px solid ${companyInfo.color}60`
                },
                '&::before': item?.visto_notf ? {} : {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: 4,
                    height: '100%',
                    background: companyInfo.color,
                    borderRadius: '0 2px 2px 0'
                }
            }}
            onClick={()=>redirect()}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                {/* Company Avatar */}
                <Avatar 
                    src={companyInfo.logo} 
                    sx={{ 
                        width: 36, 
                        height: 36,
                        border: `2px solid ${companyInfo.color}30`,
                        boxShadow: `0 2px 8px ${companyInfo.color}20`
                    }} 
                />
                
                {/* Content */}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    {/* Header with user and company */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                        <Typography 
                            sx={{ 
                                color: isDarkMode ? '#e0e0e0' : '#2d3748', 
                                fontSize: 14, 
                                fontWeight: 600,
                                lineHeight: 1.2
                            }}
                        >
                            {item?.senduser?.nombre_p || 'Usuario'}
                        </Typography>
                        <Chip 
                            label={companyInfo.name}
                            size="small"
                            sx={{
                                height: 20,
                                fontSize: 10,
                                fontWeight: 600,
                                backgroundColor: `${companyInfo.color}15`,
                                color: companyInfo.color,
                                border: `1px solid ${companyInfo.color}30`,
                                '& .MuiChip-label': {
                                    px: 1
                                }
                            }}
                        />
                    </Box>

                    {/* Assignment text */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                        {assignmentInfo.icon && (
                            <Box sx={{ color: assignmentInfo.color }}>
                                {assignmentInfo.icon}
                            </Box>
                        )}
                        <Typography 
                            sx={{ 
                                color: isDarkMode ? '#b0bec5' : '#4a5568', 
                                fontSize: 13, 
                                lineHeight: 1.3
                            }}
                        >
                            {assignmentInfo.text} en el ticket
                        </Typography>
                        <Chip 
                            icon={<ConfirmationNumberIcon sx={{ fontSize: 14 }} />}
                            label={`#${item?.ticketId_notf}`}
                            size="small"
                            sx={{
                                height: 18,
                                fontSize: 11,
                                fontWeight: 700,
                                ml: 0.5,
                                backgroundColor: 'rgba(3, 100, 255, 0.1)',
                                color: '#0364FF',
                                '& .MuiChip-label': {
                                    px: 0.5
                                },
                                '& .MuiChip-icon': {
                                    fontSize: 12,
                                    ml: 0.5,
                                    color: '#0364FF'
                                }
                            }}
                        />
                    </Box>

                    {/* Time info */}
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <AccessTimeOutlinedIcon sx={{ fontSize: 12, color: '#a0aec0' }} />
                            <Typography sx={{ color: '#a0aec0', fontSize: 11 }}>
                                {FechaFunction.timeAgoMentions(new Date(item?.createdAt))}
                            </Typography>
                        </Box>
                        
                        {item?.visto_notf && (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <RemoveRedEyeIcon sx={{ fontSize: 12, color: '#029e3e' }} />
                                <Typography sx={{ color: '#029e3e', fontSize: 11 }}>
                                    Visto {FechaFunction.timeAgoMentions(new Date(item?.visto_notf))}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>
        </Card>
    )
}

export default CardNotifications